import { useLocalStorage } from '@vueuse/core';
import { defineStore } from 'pinia';
import { computed, watch } from 'vue';

interface Workspace {
  serverUrl: string;
  name: string;
}

export const SELECTED_WORKSPACE_LOCALSTORAGE_KEY = 'nora.selectedWorkspace';
export const WORKSPACES_LOCALSTORAGE_KEY = 'nora.workspaces';

export const useWorkspaceStore = defineStore('workspaceStore', () => {
  const workspaces = useLocalStorage<Workspace[]>(WORKSPACES_LOCALSTORAGE_KEY, []);

  const selectedWorkspaceUrl = useLocalStorage<string | null>(
    SELECTED_WORKSPACE_LOCALSTORAGE_KEY,
    null,
  );

  const selectedWorkspace = computed(() => {
    return workspaces.value.find(
      workspace => workspace.serverUrl === selectedWorkspaceUrl.value,
    );
  });

  function addWorkspace(workspace: Workspace): void {
    if (
      workspaces.value.some(
        existingWorkspace =>
          existingWorkspace.serverUrl === workspace.serverUrl,
      )
    ) {
      selectedWorkspaceUrl.value = workspace.serverUrl;
      return;
    }
    workspaces.value.push(workspace);
    selectedWorkspaceUrl.value = workspace.serverUrl;
  }

  function removeWorkspace(serverUrl: string): void {
    workspaces.value = workspaces.value.filter(
      workspace => workspace.serverUrl !== serverUrl,
    );
    if (selectedWorkspaceUrl.value === serverUrl) {
      selectedWorkspaceUrl.value = workspaces.value[0]?.serverUrl ?? null;
    }
  }

  watch(selectedWorkspaceUrl, () => {
    window.location.reload();
  });

  return {
    workspaces,
    selectedWorkspace,
    selectedWorkspaceUrl,
    addWorkspace,
    removeWorkspace,
  };
});
